// Accounting sub-sections. The section switch lives in the org sidebar as a
// submenu under "Accounting" (each links to /accounting/<slug>), so this list is
// the single source of truth shared by the sidebar and the accounting shell.
// Kept free of component imports so the sidebar bundle stays light.
//
// The order and the labels mirror the LIVE legacy accounting sidebar
// (siderbar_data.jsx:102-163), which has eight entries. Two of them are not
// ported yet because no backend route serves them, so they are absent here
// rather than present and broken:
//   - "Sales Dashboard" (siderbar_data.jsx:109-110)
//   - "Letter Processing Records" (siderbar_data.jsx:151-152)
// There is no "Invoices" entry: that grid only ever hung off AccountingTab.jsx,
// the previous shell, which nothing routes to. The live equivalents are the
// Accounts Receivable and Accounts Payable tabs.
export const ACCOUNTING_BASE = '/accounting';

export type AccountingSlug =
  | 'reports'
  | 'payable'
  | 'receivable'
  | 'transactions'
  | 'advance'
  | 'settings';

export const ACCOUNTING_NAV: ReadonlyArray<{ slug: AccountingSlug; label: string }> = [
  { slug: 'reports', label: 'Reports' },
  { slug: 'payable', label: 'Accounts Payable' },
  { slug: 'receivable', label: 'Accounts Receivable' },
  { slug: 'transactions', label: 'Transactions & Allocations' },
  { slug: 'advance', label: 'Advanced Accounting' },
  { slug: 'settings', label: 'Settings' },
];

export function accountingHref(slug: AccountingSlug): string {
  return `${ACCOUNTING_BASE}/${slug}`;
}
